const TOKEN_KEY = "harshait_token";
const USER_KEY = "harshait_user";

/*
|--------------------------------------------------------------------------
| TOKEN
|--------------------------------------------------------------------------
*/

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};


/*
|--------------------------------------------------------------------------
| USER
|--------------------------------------------------------------------------
*/

export const getStoredUser = () => {
  try {
    const user = localStorage.getItem(USER_KEY);

    if (!user) {
      return null;
    }

    return JSON.parse(user);
  } catch (error) {
    console.error("Unable to parse stored user:", error);

    localStorage.removeItem(USER_KEY);

    return null;
  }
};

export const setStoredUser = (user) => {
  localStorage.setItem(
    USER_KEY,
    JSON.stringify(user)
  );
};

export const removeStoredUser = () => {
  localStorage.removeItem(USER_KEY);
};


/*
|--------------------------------------------------------------------------
| AUTH STORAGE
|--------------------------------------------------------------------------
*/

export const clearAuthStorage = () => {
  removeToken();
  removeStoredUser();
};

export const hasToken = () => {
  return Boolean(getToken());
};